import { useTranslation } from "react-i18next";
import { IPortinSlot } from "../IPortinSlot";
import { Controller, UseFormMethods } from "react-hook-form";
import { IPortinForm } from "../IPortinForm";
import { DatePicker, MuiPickersUtilsProvider } from "@material-ui/pickers";
import DateFnsUtils from "@date-io/date-fns";
import { format, max, min } from "date-fns";

interface IParams {
    formMethod: UseFormMethods<IPortinForm>;
    fullWidth?: boolean;
    portinSlotList: IPortinSlot[];
}

export const PortInDate = (props: IParams) => {
    const { formMethod, portinSlotList, fullWidth } = props;
    const { errors, control } = formMethod;
    const { t } = useTranslation(["portin", "validation"]);

    // Empty array passed to min or max will result in invalid date which cannot be formatted
    const portinSlotDateList = portinSlotList.length
        ? portinSlotList.map((portinSlot) => portinSlot.date)
        : [new Date()];
    const portinMinDate = min(portinSlotDateList);
    const portinMaxDate = max(portinSlotDateList);

    return (
        <MuiPickersUtilsProvider utils={DateFnsUtils}>
            <Controller
                control={control}
                name="date"
                render={(controllerRenderProps) => (
                    <DatePicker
                        autoOk
                        className="xtest_date_input"
                        disableToolbar
                        error={Boolean(errors.date)}
                        format="dd/MM/yyyy"
                        fullWidth={fullWidth}
                        helperText={errors.date?.message}
                        id="moveDate"
                        inputRef={controllerRenderProps.ref}
                        label={`${t("portin:moveDate")} *`}
                        maxDate={portinMaxDate}
                        minDate={portinMinDate}
                        name="date"
                        placeholder={format(portinMinDate, "dd/MM/yyyy")}
                        value={controllerRenderProps.value}
                        onChange={controllerRenderProps.onChange}
                    />
                )}
                rules={{
                    required: t("validation:required"),
                }}
            />
        </MuiPickersUtilsProvider>
    );
};
